import React__default from 'react';
import { translations } from './translations.js';

const Context = /*#__PURE__*/React__default.createContext({
  locale: 'fi',
  translations
});
Context.displayName = 'StyleGuideContext';

export { Context };
